import { usePolicy } from 'dashboard/composables/usePolicy';
import {
  KANBAN_MODULE_PERMISSION_BY_KEY,
  modulePermission,
} from 'dashboard/constants/permissions';

/**
 * Gating de módulo do fork por FUNÇÃO do usuário.
 *
 * Regra (espelha o backend Kanban::ModuleCrudGuard): admin e agente/admin BASE veem
 * tudo (o gating do fork sempre foi por função personalizada); a função personalizada
 * só vê/faz o que foi concedido.
 *
 * - moduleAllowed(mod)        → "Ver" o módulo (menu/tela) = `<mod>_module`.
 * - moduleCan(action, mod)    → ação CRUD ('create' | 'update' | 'delete') no módulo =
 *   `<mod>_<action>`. Use p/ ESCONDER botões de criar/editar/excluir conforme a
 *   permissão (o backend recusa de todo jeito, mas o botão não deve nem aparecer).
 */
export function useModulePermissions() {
  const { checkPermissions } = usePolicy();

  const moduleAllowed = mod =>
    checkPermissions([
      'administrator',
      'agent',
      KANBAN_MODULE_PERMISSION_BY_KEY[mod],
    ]);

  const moduleCan = (action, mod) =>
    checkPermissions([
      'administrator',
      'agent',
      modulePermission(mod, action),
    ]);

  return { moduleAllowed, moduleCan };
}
